module.exports = __webpack_public_path__ + "static/media/ChiswickHeadline-Extralight-Web.6564d4f1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/ChiswickHeadline-Extralight-Web.woff2
// module id = 74
// module chunks = 0